const env = {
    ENV: "dev",
    API_BASE_URL: "https://api.appsmart.com.co/api/v1/",
};

export default env;
